import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';

export const Helpers = {
	// Converts a date/time to a given time zone (for displaying as if in "local time" like timezoneDisplayService.convert)
	convertTimeZone(date, timeZone) {
		return moment(moment.tz(date, timeZone).format('YYYY-MM-DD HH:mm:ss')).locale('en-ltf');
	},

	log(...data) {
		if (import.meta.env.MODE === 'test' || import.meta.env.MODE === 'uitest') return; // NEVER console.log in the unit tests.
		// eslint-disable-next-line no-console
		if (console && console.log) console.log(data);
	},

	isDev() {
		return import.meta.env.MODE === 'development';
	},

	isUiTest() {
		return import.meta.env.MODE === 'uitest';
	},

	isDevOrUi() {
		return import.meta.env.MODE === 'development' || import.meta.env.MODE === 'uitest';
	},

	isMobileApp() {
		return window.location.pathname.indexOf('.app.html') > -1;
	},

	objectToQueryString(obj) {
		return Object.keys(obj).map(key => {
			if (typeof obj[key] !== 'object') return key + '=' + encodeURIComponent(obj[key]);

			let ret = [];
			for (const idx in obj[key]) {
				ret.push(key+'='+encodeURIComponent(obj[key][idx]));
			}
			return ret.join('&');
		}).filter(val => val).join('&');
	},

	levelToInt(level) {
		switch (true) {
			// founders workarounds for gem mapping
			case (/founders\ssingle/i.test(level)):
			case (/founders\ssignature/i.test(level)):
			case (/founders\sfamily/i.test(level)):
			case (/founders\sflex/i.test(level)):
			case (/founders\scouple/i.test(level)):
				return 4;  // onyx

			// normal cases
			case (/bronze/i.test(level)): return 1;
			case (/gold/i.test(level)): return 2;
			case (/platinum/i.test(level)): return 3;
			case (/onyx/i.test(level)): return 4;
			case (/diamond/i.test(level)): return 5;
			default: return 0;
		}
	},

	levelToString(level) {
		switch (level) {
			case 1: return 'bronze';
			case 2: return 'gold';
			case 3: return 'platinum';
			case 4: return 'onyx';
			case 5: return 'diamond';
			default: return '';
		}
	},

	parseDateToMoment(dateStr) {
		return moment(dateStr, 'YYYY-MM-DD', false);
	},

	// startTime and endTime in "h:mm tt" format
	parseTimes(startTime, endTime) {
		const start = startTime.split(' ');
		const end = endTime.split(' ');
		let startAMPM = '';
		if (start[1] !== end[1]) {
			startAMPM = `<span class="time-ampm"> ${start[1]}</span>`;
		}
		return `<span><time class="time-start">${start[0]}${startAMPM}</time> <span class="time-to">to</span> <time class="time-end">${end[0]}<span class="time-ampm"> ${end[1]}</span></time></span>`;
	},

	buildInstructors(instructors) {
		if (!instructors || instructors.length === 0) return '';

		let ret = '';
		for (let i=0; i < instructors.length; i++) {
			const instructor = instructors[i];
			if (instructor.isSubstitute) {
				ret += `<span class="card-instructor-sub">${instructor.name}</span>`;
			} else {
				ret += `${instructor.name}`;
			}
			if (i+1 !== instructors.length)	{
				if (instructors.length === 2) {
					ret+= ' and ';
				} else if (i === instructors.length-2) {
					ret+= ', and ';
				} else {
					ret+= ', ';
				}
			}
		}
		return ret;
	},

	urlify(filters) {
		var queryString = '';
		_.forEach(filters, function(value, key) {
			var field;

			switch (key) {
				case 'loc':
					field = '&location=';
					break;
				case 'int':
					field = '&interest=';
					break;
				case 'dep':
					field = '&departmentDescription=';
					break;
				case 'ins':
					field = '&instructor=';
					break;
				case 'tod':
					field = '&timeOfDay=';
					break;
				case 'age':
					field = '&age=';
					break;
				case 'iny':
					field = '&intensity=';
					break;
				case 'skl':
					field = '&skillLevel=';
					break;
				case 'fre':
					field = '&showOnlyFree=';
					break;
				case 'res':
					field = '&resource=';
					break;
				case 'tmv':
					field = '&teamMemberView=';
					break;
				default:
			}

			if (typeof(value) === 'boolean') {
				queryString += field + value;
			} else {
				value = _.map(value, function(filterArrayItem) {
					return encodeURIComponent(filterArrayItem);
				});
				if (field) {
					queryString += field + value.join(field);
				}
			}
		});
		return queryString;
	},

	// Get the position of a DOM element (see https://www.quirksmode.org/js/findpos.html)
	getPosition(domElement) {
		let curleft = 0;
		let curtop = 0;
		if (domElement.offsetParent) {
			do {
				curleft += domElement.offsetLeft;
				curtop += domElement.offsetTop;
				domElement = domElement.offsetParent;
			} while (domElement);
		}
		return [curleft, curtop];
	}
};

